import {Component, OnInit} from '@angular/core';
import {ComuneService} from "../../../../../shared/services/comune.service";
import {FormControl} from "@angular/forms";
import {
    AbstractDefaultComponent
} from "../../../../../shared/abstracts/abstract-default-component/abstract-default-component";
import {distinctUntilChanged, takeUntil} from "rxjs";

@Component({
    selector: 'app-select-comune',
    templateUrl: './select-comune.component.html',
    styleUrls: ['./select-comune.component.scss'],
    standalone: false
})
export class SelectComuneComponent extends AbstractDefaultComponent implements OnInit {

    formControl = new FormControl();

    constructor(public comuneService: ComuneService) {
        super();

        this.comuneService.slugComune$.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe((value) => {
            if(value){
                this.formControl.setValue(value, {emitEvent: false})
            }
        })
    }

    ngOnInit(): void {
        this.formControl.setValue(this.comuneService.getSlugComune, {emitEvent: false})
        this.formControl.valueChanges.pipe(takeUntil(this.destroy$), distinctUntilChanged()).subscribe((value) => {
            this.comuneService.setComune(value)
        })
    }

}
